import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function Guide() {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [status, setStatus] = useState('idle');
    const [error, setError] = useState('');

    const clearError = () => {
        if (status === 'error') {
            setStatus('idle');
            setError('');
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const trimmedEmail = email.trim();
        if (!EMAIL_PATTERN.test(trimmedEmail)) {
            setError('Please enter a valid email address.');
            setStatus('error');
            return;
        }

        setStatus('submitting');
        setError('');

        try {
            const payload = { email: trimmedEmail };
            const trimmedName = firstName.trim();
            if (trimmedName) {
                payload.firstName = trimmedName;
            }

            const response = await fetch('/api/lead-magnet', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
                setError(data.error || 'Something went wrong. Please try again.');
                setStatus('error');
                return;
            }
            setStatus('success');
        } catch {
            setError('Something went wrong. Please try again.');
            setStatus('error');
        }
    };

    return (
        <div className="min-h-screen">
            <section className="relative bg-gradient-to-br from-blue-200 via-blue-100 to-sky-100">
                <div className="max-w-3xl mx-auto px-4 py-16 sm:py-20">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 text-gray-800">
                        Free guide: 7 ways to carry epinephrine (EpiPen, Auvi-Q, neffy)
                    </h1>
                    <p className="text-base sm:text-lg text-gray-700 mb-8">
                        This guide is free. Enter your email below and we will send it to you.
                    </p>

                    <div className="bg-white rounded-xl shadow-md p-6 sm:p-8">
                        {status === 'success' ? (
                            <p className="text-gray-700">
                                Check your inbox for the guide. If you do not see it, look in spam or promotions.
                            </p>
                        ) : (
                            <form onSubmit={handleSubmit} className="space-y-4" noValidate>
                                <div>
                                    <label
                                        htmlFor="guide-email"
                                        className="block text-sm font-medium text-gray-700 mb-1"
                                    >
                                        Email
                                    </label>
                                    <input
                                        id="guide-email"
                                        name="email"
                                        type="email"
                                        required
                                        autoComplete="email"
                                        value={email}
                                        onChange={(event) => {
                                            setEmail(event.target.value);
                                            clearError();
                                        }}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary"
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor="guide-first-name"
                                        className="block text-sm font-medium text-gray-700 mb-1"
                                    >
                                        First name{' '}
                                        <span className="text-gray-400 font-normal">(optional)</span>
                                    </label>
                                    <input
                                        id="guide-first-name"
                                        name="firstName"
                                        type="text"
                                        autoComplete="given-name"
                                        value={firstName}
                                        onChange={(event) => {
                                            setFirstName(event.target.value);
                                            clearError();
                                        }}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={status === 'submitting'}
                                    className="w-full sm:w-auto bg-primary hover:bg-primary/90 disabled:opacity-70 text-white px-4 py-3 rounded-lg text-base font-semibold transition-colors duration-200"
                                >
                                    {status === 'submitting' ? 'Sending…' : 'Send me the free guide'}
                                </button>
                                {error ? (
                                    <p role="alert" className="text-sm text-red-600">
                                        {error}
                                    </p>
                                ) : null}
                            </form>
                        )}
                    </div>

                    <p className="mt-6 text-sm text-gray-600">
                        We only use your email to send the guide and occasional updates. See our{' '}
                        <span className="whitespace-nowrap">
                            <Link
                                to="/PrivacyPolicy"
                                className="text-gray-800 underline hover:text-primary"
                            >
                                Privacy Policy
                            </Link>
                            .
                        </span>
                    </p>
                </div>
            </section>
        </div>
    );
}

export default Guide;
